/**
 * 
 * @param {*} active 激活时的类名 
 * @param {*} navElems 导航栏标签的子集 类似ui里面的li
 * @param {*} scrollName 盒子id名称
 */export function navMapScroll(active, navElems, scrollName) {
  let pageEqClass = {};
  let navEqClass = {};

  // 使用更现代的JavaScript语法
  navElems.forEach((item, index) => {
    let className = `${scrollName}${index + 1}`; // 盒子id名称
    pageEqClass[className] = document.querySelector(`#${className}`);
    navEqClass[className] = item; // id 对应的导航栏标签
  });

  // 防抖函数优化
  function debounce(fn, wait) {
    let timeout;
    return function (...args) {
      if (timeout) {
        clearTimeout(timeout);
      }
      timeout = setTimeout(() => {
        fn(...args);
      }, wait);
    };
  }

  // 获取页面滚动位置和元素尺寸的函数
  function getScrollTop() {
    return window.pageYOffset || window.document.documentElement.scrollTop;
  }

  function getClientWidth() {
    return document.documentElement.clientWidth;
  }

  // 主要逻辑函数
  function updateNavClasses() {
    const scrollTop = getScrollTop();
    for (let k in pageEqClass) {
      if (!pageEqClass.hasOwnProperty(k)) continue;
      const elem = pageEqClass[k];
      // 检查DOM元素是否存在且具有有效的offsetTop
      if (!elem || typeof elem.offsetTop === 'undefined') continue;
      const offsetTop = elem.offsetTop;
      const clientWidth = getClientWidth();
      const elemH = elem.offsetHeight;
      if (offsetTop - scrollTop <= 400 && offsetTop + elemH - scrollTop > 400) {
        navEqClass[k].classList.add(active);
      } else {
        navEqClass[k].classList.remove(active);
      }
    }
  }

  // 绑定滚动事件并调用一次更新函数
  window.addEventListener('scroll', debounce(updateNavClasses, 50));
  updateNavClasses();
}
/**
 * 
 * @param {*} idName 指定的盒子如 document.querySelector(`#nav_1`)
 * @param {*} price 默认100
 */
export function selectScroll(idName,price=100){
  const targetTop = idName.offsetTop - price; 
  window.scrollTo({ top: targetTop, behavior: 'smooth' });  
}